/**
 * DeceasedBadge.js — small "✟ Deceased — <date>" indicator.
 *
 * Used wherever we need to surface that an entity is dead to the user:
 *  - EntityDetail header card
 *  - Stage roster slot
 *  - Team-page row
 *
 * Visual: bone-coloured pill with a Latin cross glyph, no all-caps so it
 * reads as a note rather than a warning.
 */
import { format } from 'date-fns';

export default function DeceasedBadge({ deathDate, compact = false }) {
  if (!deathDate) return null;

  // Be permissive about input — ISO date, ISO datetime, or "YYYY-MM-DD".
  let label = deathDate;
  try {
    const d = new Date(deathDate.length === 10 ? deathDate + 'T00:00:00Z' : deathDate);
    if (!isNaN(d.getTime())) {
      label = format(d, compact ? 'yyyy' : 'MMM d, yyyy');
    }
  } catch {
    // keep raw
  }

  return (
    <span
      className={
        compact
          ? 'inline-flex items-center gap-1 text-[10px] font-medium text-muted-foreground/90'
          : 'inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[11px] font-medium bg-muted/70 text-muted-foreground border border-border/60'
      }
      data-testid="deceased-badge"
      title={`Deceased ${deathDate}`}
    >
      <span aria-hidden>✟</span>
      <span>Deceased{compact ? ' ' : ' · '}{label}</span>
    </span>
  );
}
